import styled, { css } from 'styled-components';
import { key } from 'styled-theme';

const style = css`
  font-family: 'Brix Sans', sans-serif;
  color: ${key('text.primary')};
  border: ${key('outlines.border')};
  border-radius: ${key('sizes.borderRadius')};
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  padding: 13px 20px 13px 50px;
  outline: none;

  &:focus {
    border-color: ${key('global.primary')};
    box-shadow: ${key('outlines.shadow.active')};
  }
`;

export const Textarea = styled.textarea`
  ${style};
`;

export default styled.input`
  ${style};
`;
